module.exports = __webpack_public_path__ + "img/13.0700ad82.png";